import { Injectable, signal } from '@angular/core';
import { ReleaseNotesModalComponent } from '../components/release-notes-modal/release-notes-modal.component';

@Injectable({ providedIn: 'root' })
export class ReleaseNotesModalService {
  private readonly modal = signal<ReleaseNotesModalComponent | null>(null);

  register(modal: ReleaseNotesModalComponent): void {
    this.modal.set(modal);
  }

  open(): void {
    this.modal()?.open();
  }
}
